export default function getFileSize(lengthInBytes: number): string {
  if (lengthInBytes < 1024) {
    return `${dotToComma(lengthInBytes)} B`;
  }
  if (lengthInBytes < 1024 * 1024) {
    return `${dotToComma((lengthInBytes / 1024).toFixed(1))} kB`;
  }
  return `${dotToComma((lengthInBytes / 1024 / 1024).toFixed(1))} MB`;
}

function dotToComma(value: number | string): string {
  return value.toString().replace(/\./g, ',');
}
